import novusExampleStr1 from "!!raw-loader!..\\..\\..\\..\\content\\blog\\novus\\todoModel.ts";
import novusExampleStr from "!!raw-loader!..\\..\\..\\..\\content\\blog\\novus\\example.tsx";
import React from 'react';
export default {
  novusExampleStr1,
  novusExampleStr,
  React
};